/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import ProductCardGroup from '../ProductGroupCard/ProductGroupCard'
import { CHUNK_SIZE, chunkArray } from '../../helpers/AvailabilityHelper'
import getCitrusBannersx from '../../services/CitrusServiceBannerx'
import { mergeBannerGrid } from '../../helpers/ProductHelper'

const ProductList = props => {
  const { products, hideSponsoredContent, categoryName, searchTerm, currentPage } = props
  const [groupedProducts, setGroupedProducts] = useState(chunkArray(products, CHUNK_SIZE))
  const [bannerGrid, setBannerGrid] = useState([])

  useEffect(() => {
    if (categoryName && !searchTerm && currentPage === 1) {
      getCitrusBannersx('', categoryName?.toLowerCase(), 'argos-category', false).then(data => {
        if (data?.ads?.[0]?.banners?.length > 0) {
          setBannerGrid(data.ads[0].banners || [])
        }
      })
    }
    if (currentPage > 1) setBannerGrid([])
  }, [currentPage])

  const checkHowManySponsoredProducts = productGroup => {
    let sponsoredProducts = 0
    productGroup.forEach(product => {
      if (product?.type === 'sponsored-product') {
        sponsoredProducts += 1
      }
    })
    return sponsoredProducts
  }

  useEffect(() => {
    if (bannerGrid?.length > 0) {
      // We only check the first 7 products where we can have up to 3 sponsored products and one CMS grid banner
      // Find index for citrus grid banner
      const updatedProducts = [...products]
      // Just to check the first 7 products, no need to go through all products
      const firstSevenProducts = updatedProducts.slice(0, 7)
      const bannerGridPosition = checkHowManySponsoredProducts(firstSevenProducts) + 3

      // Get the index of the CMS banner to be replaced
      const cmsGridIndex = firstSevenProducts.findIndex(
        product => product?.type === 'M053' && product?.urgent === false
      )

      // If there's CMS grid banner and it is not urgent, replace it with citrus grid banner
      if (cmsGridIndex !== -1) {
        updatedProducts[cmsGridIndex] = mergeBannerGrid(categoryName, bannerGrid[0])
      }

      // If there's no CMS grid banner, insert citrus grid banner
      if (!firstSevenProducts.some(product => product?.type === 'M053')) {
        updatedProducts.splice(bannerGridPosition, 0, mergeBannerGrid(categoryName, bannerGrid[0]))
      }

      // If there's CMS grid banner and it is urgent, don't replace and don't show citrus grid banner
      setGroupedProducts(chunkArray(updatedProducts, CHUNK_SIZE))
    } else {
      setGroupedProducts(chunkArray(products, CHUNK_SIZE))
    }
  }, [bannerGrid, products])

  return (
    <ErrorBoundary>
      <div data-test='product-list'>
        {groupedProducts.map((chunkProduct, groupIndex) => {
          return (
            <ProductCardGroup
              chunkProduct={chunkProduct}
              groupIndex={groupIndex}
              {...props}
              key={groupIndex}
              hideSponsoredContent={hideSponsoredContent}
            />
          )
        })}
      </div>
    </ErrorBoundary>
  )
}

ProductList.propTypes = {
  destinationPageType: PropTypes.string,
  products: PropTypes.array.isRequired,
  showLoader: PropTypes.bool,
  hideSponsoredContent: PropTypes.bool,
  categoryName: PropTypes.string,
  searchTerm: PropTypes.string,
  currentPage: PropTypes.number.isRequired
}

ProductList.defaultProps = {
  destinationPageType: '',
  showLoader: false,
  hideSponsoredContent: false,
  categoryName: null,
  searchTerm: null
}

export default ProductList
